import React from 'react';
import { motion } from 'framer-motion';

const SectionWrapper = ({ id, eyebrow, title, subtitle, action, children, className = '' }) => (
  <section id={id} className={`py-20 md:py-24 scroll-mt-20 ${className}`} data-testid={`section-${id}`}>
    <div className="mx-auto max-w-7xl px-6">
      {(eyebrow || title) && (
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10"
        >
          <div>
            {eyebrow && <p className="text-xs font-bold uppercase tracking-[0.18em] text-brand mb-3">{eyebrow}</p>}
            {title && <h2 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight text-ink">{title}</h2>}
            {subtitle && <p className="mt-3 text-base md:text-lg text-slate-500">{subtitle}</p>}
          </div>
          {action}
        </motion.div>
      )}
      {children}
    </div>
  </section>
);

export default SectionWrapper;
